import { aboutContent } from '@/mocks/home';

export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {aboutContent.title}
          </h2>
        </div>

        <div className="bg-background-100 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <div className="space-y-5 md:space-y-6">
            {aboutContent.paragraphs.map((paragraph, idx) => (
              <p
                key={idx}
                className="text-sm md:text-base text-foreground-700 leading-relaxed"
              >
                {paragraph}
              </p>
            ))}
          </div>

          <div className="mt-8 md:mt-10 pt-6 md:pt-8 border-t border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
              <div>
                <div className="text-2xl md:text-3xl font-bold text-primary-500">2019</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">创始年份</div>
              </div>
              <div>
                <div className="text-2xl md:text-3xl font-bold text-accent-500">12,800+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">累计爆料</div>
              </div>
              <div>
                <div className="text-2xl md:text-3xl font-bold text-secondary-500">360万+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">月活读者</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}